<div class="ind-wrapper-form-mobile">
  <div class="ind-triangle-bg">
    <h2 class="form-subtitle-text center">
      {{ 'register.already-have-an-account' | translate }}
    </h2>
    <app-button
      class="ind-btn-wrapper-100"
      label="buttons.labels.signin"
      [className]="screenSize === 'Mobile' ? 'ind-btn--secondary' : 'ind-btn--primary'"
      (click)="onGoToLogin()">
    </app-button>
    <p class="register-info-desc">
      {{ 'register.description2' | translate }}
    </p>
  </div>
</div>
